// extracted by mini-css-extract-plugin
module.exports = {"socialItem":"SocialLink_socialItem__297_G","socialItemLink":"SocialLink_socialItemLink__11sCJ"};